import React from 'react';
import axios from "axios";
import { loadable } from 'react-lazily/loadable';
const { TranslationMessage } = loadable(() => import('components'), {
fallback: <>Loading...</>,
});


interface IndexComponentProps { }
const Index: React.FunctionComponent<IndexComponentProps> = (props): JSX.Element => {
	const baseURL = "http://repo.amniltech.com:7373/content/get_latest_fee_charges";
	const [post, setPost] = React.useState<any>([]);

	React.useEffect(() => {
		axios.get(baseURL).then((response) => {
			setPost(response.data);
		});
	}, []);

	return (
		<>
			<div className="container mb-5 mt-3">
				<div>
					{post?.data?.map(x => <TranslationMessage data={x} value="long_description" isHtmlParse />)}
				</div>
			</div>
		</>
	);
};

export default Index;
